// 初始化、清除、重置 redux ec 狀態
export const INIT_EC_REDUX = 'initEcRedux';

export const FETCH_PRODUCT_DETAIL = {
  LOADING: 'fetchProductDetailLoading',
  SUCCESS: 'fetchProductDetailSuccess',
  FAIL: 'fetchProductDetailFail'
};
export const FETCH_PRODUCT_ITEMS = {
  LOADING: 'fetchProductItemsLoading',
  SUCCESS: 'fetchProductItemsSuccess',
  FAIL: 'fetchProductItemsFail'
};

export const FETCH_PRODUCT_LOCALTOUR = {
  LOADING: 'fetchProductLocalTourLoading',
  SUCCESS: 'fetchProductLocalTourSuccess',
  FAIL: 'fetchProductLocalTourFail'
};

export const FETCH_PRODUCT_TICKET = {
  LOADING: 'fetchProductTicketLoading',
  SUCCESS: 'fetchProductTicketSuccess',
  FAIL: 'fetchProductTicketFail'
};

export const FETCH_PRODUCT_CAR_RENTAL = {
  LOADING: 'fetchProductCarRentalLoading',
  SUCCESS: 'fetchProductCarRentalSuccess',
  FAIL: 'fetchProductCarRentalFail'
};

export const FETCH_PRODUCT_SIM_WIFI = {
  LOADING: 'fetchProductSimWifiLoading',
  SUCCESS: 'fetchProductSimWifiSuccess',
  FAIL: 'fetchProductSimWifiFail'
};

export const FETCH_PRODUCT_AGENT = {
  LOADING: 'fetchProductAgentLoading',
  SUCCESS: 'fetchProductAgentSuccess',
  FAIL: 'fetchProductAgentFail'
};

export const FETCH_PRODUCT_COST_ESTIMATION = {
  LOADING: 'fetchProductCostEstimationLoading',
  SUCCESS: 'fetchProductCostEstimationSuccess',
  FAIL: 'fetchProductCostEstimationFail'
};

export const SET_COPY_PRODUCT_POPUP = {
  SHOW: 'setCopyProductPopupShow',
  CLOSE: 'setCopyProductPopupClose'
};
export const SET_PRODUCT_SHARE = {
  SHOW: 'setProductShareShow',
  CLOSE: 'setProductShareClose'
};

export const SET_PRODUCT_LIKE = 'setProductLike';

export const COPY_PRODUCT = {
  INIT: 'copyProductInit',
  LOADING: 'copyProductLoading',
  SUCCESS: 'copyProductSuccess',
  FAIL: 'copyProductFail'
};

export const CHECK_PRODUCT_STOCK = {
  INIT: 'checkProductStockInit',
  LOADING: 'checkProductStockLoading',
  SUCCESS: 'checkProductStockSuccess',
  FAIL: 'checkProductStockFail'
};
export const RESET_PRODUCT_STOCK_CODE = 'resetProductStockCode';
export const SET_FOOTER_PADDING_BOTTOM = 'setFooterPaddingBottom';

export const FETCH_CREDIT_CARDS = {
  LOADING: 'fetchCreditCardsLoading',
  SUCCESS: 'fetchCreditCardsSuccess',
  FAIL: 'fetchCreditCardsFail'
};

export const DELETE_CREDIT_CARDS = {
  LOADING: 'deleteCreditCardsLoading',
  SUCCESS: 'deleteCreditCardsSuccess',
  FAIL: 'deleteCreditCardsFail'
};

export const POST_PAY = {
  LOADING: 'postPayLoading',
  SUCCESS: 'postPaySuccess',
  FAIL: 'postPayFail'
};
export const FETCH_ORDER_LIST = {
  LOADING: 'fetchOrderListLoading',
  SUCCESS: 'fetchOrderListSuccess',
  FAIL: 'fetchOrderListFail',
  NEXT: 'fetchOrderListNext'
};

export const FETCH_ORDER_DETAIL = {
  LOADING: 'fetchOrderDetailLoading',
  SUCCESS: 'fetchOrderDetailSuccess',
  FAIL: 'fetchOrderDetailFail'
};

export const PUT_ORDER_INSUREDS = {
  LOADING: 'putOrderInsuredsLoading',
  SUCCESS: 'putOrderInsuredsSuccess',
  FAIL: 'putOrderInsuredsFail'
};

export const PUT_ORDER_PARTNERS = {
  LOADING: 'putOrderPartnersLoading',
  SUCCESS: 'putOrderPartnersSuccess',
  FAIL: 'putOrderPartnersFail'
};

export const FETCH_CURRENT_TRIP = {
  INIT: 'fetchCurrentTripInit',
  LOADING: 'fetchCurrentTripLoading',
  SUCCESS: 'fetchCurrentTripSuccess',
  FAIL: 'fetchCurrentTripFail'
};

export const SET_OPTION_INTERSECTING = 'setOptionIntersecting';
export const SET_ADD_TRIP_STEP = 'setAddTripStep';
export const CLEAR_CURRENT_TRIP = 'clearCurrentTrip';

export const SET_PRODUCT_AUTHOR_FOLLOWING = 'setProductAuthorFollowing';
